import { render } from "./QHLSExam.vue?vue&type=template&id=12af0347&scoped=true"
import script from "./QHLSExam.vue?vue&type=script&lang=js"
export * from "./QHLSExam.vue?vue&type=script&lang=js"

import "./QHLSExam.vue?vue&type=style&index=0&id=12af0347&lang=css"
import "./QHLSExam.vue?vue&type=style&index=1&id=12af0347&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12af0347"]])

export default __exports__